import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMultiDomains } from 'utils/isMultiDomain';
import config from 'utils/config';
import filterObject from 'utils/filterObject';
import { DefaultFormFieldLayout } from 'components/FormField';
import TitleCard from 'components/TitleCard';
import UnsavedChangesBlockerModal from 'screens/UnsavedChangesBlockerModal';
import FormStack from 'components/FormStack';
import Stack from 'components/Stack';
import Hint from 'components/Hint';
import { formatTags, useHandleMultiSelectTags, AssetOwningTeamField, CompletionTimeField, LanguageField, MarkAsDoneModeField, TagField, ExcludeFromAIField } from 'components/FormFields';
import { EditorPageStickySaveDiscardButton } from 'components/EditorPageStickyFooter';
import { useMultiAssetsForm } from './useMultiAssetsForm';
import { isMindsetBankConfigured } from 'utils/mindset/mindsetHubConfig';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function useIncludesScormCourses(items) {
  return useMemo(function () {
    return items.some(function (asset) {
      return asset.type === 'scorm';
    });
  }, [items]);
}
function getNewAssetTags(_ref) {
  var asset = _ref.asset,
    tagsToAdd = _ref.tagsToAdd,
    tagsToRemove = _ref.tagsToRemove;
  if (!tagsToAdd.length && !tagsToRemove.length) {
    return undefined;
  }
  var currentTags = asset.tags || [];
  var tagsToAddCleaned = tagsToAdd.filter(function (tag) {
    return !currentTags.some(function (t) {
      return t.id === tag.id;
    });
  });
  var updatedTags = [].concat(_toConsumableArray(currentTags), _toConsumableArray(tagsToAddCleaned)).filter(function (tag) {
    return !tagsToRemove.some(function (removeTag) {
      return removeTag.id === tag.id;
    });
  });
  return updatedTags;
}
function MultiAssetDetailsPage(_ref2) {
  var initialAssetDetailItems = _ref2.initialAssetDetailItems,
    onSubmit = _ref2.onSubmit,
    onClose = _ref2.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmissionLoading = _useState2[0],
    setIsSubmissionLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    pendingCloseAfterSubmit = _useState4[0],
    setPendingCloseAfterSubmit = _useState4[1];
  var assetIds = initialAssetDetailItems.map(function (asset) {
    return asset.id;
  });
  var domainIds = initialAssetDetailItems.map(function (asset) {
    return asset.domain_id;
  });
  var containsDistributed = isMultiDomains(domainIds);
  var includesScormCourses = useIncludesScormCourses(initialAssetDetailItems);
  var _useHandleMultiSelect = useHandleMultiSelectTags({
      initialContentItems: initialAssetDetailItems,
      contentIds: assetIds
    }),
    wereTagsChanged = _useHandleMultiSelect.wereTagsChanged,
    selectedTags = _useHandleMultiSelect.selectedTags,
    tagsToRemove = _useHandleMultiSelect.tagsToRemove,
    tagsToAdd = _useHandleMultiSelect.tagsToAdd,
    addTag = _useHandleMultiSelect.addTag,
    removeTag = _useHandleMultiSelect.removeTag,
    resetTags = _useHandleMultiSelect.resetTags;
  var assetForm = useMultiAssetsForm({
    assets: initialAssetDetailItems
  });
  var fields = assetForm.fields,
    hasErrors = assetForm.hasErrors,
    wasChanged = assetForm.wasChanged,
    reset = assetForm.reset;
  var hasChanges = wasChanged || wereTagsChanged;

  // Close only after reset clears dirty state; otherwise the blocker can
  // intercept URL cleanup and leave `modal=edit-content` behind.
  useEffect(function () {
    if (!pendingCloseAfterSubmit || hasChanges) {
      return;
    }
    setPendingCloseAfterSubmit(false);
    onClose();
  }, [pendingCloseAfterSubmit, hasChanges, onClose]);
  function resetAll() {
    reset();
    resetTags();
  }
  var commonExcludeFromAi = function () {
    var isAllExcludeFromAiTheSame = initialAssetDetailItems.every(function (item) {
      return (item.excludeFromAi || item.excludedFromAiByParent) === (initialAssetDetailItems[0].excludeFromAi || initialAssetDetailItems[0].excludedFromAiByParent);
    });
    var allExcludedByParent = initialAssetDetailItems.every(function (item) {
      return item.excludedFromAiByParent;
    });
    var excludedByParent = initialAssetDetailItems.some(function (item) {
      return item.excludedFromAiByParent;
    });
    var description = excludedByParent ? t('hint_multi_exclude_from_ai_distributed_content') : '';
    var excludeResult;
    if (initialAssetDetailItems.length) {
      if (isAllExcludeFromAiTheSame) {
        excludeResult = initialAssetDetailItems[0].excludeFromAi || initialAssetDetailItems[0].excludedFromAiByParent;
      } else {
        excludeResult = 'mixed';
      }
    }
    return {
      excludeResult: excludeResult,
      description: description,
      allExcludedByParent: allExcludedByParent
    };
  }();
  var hasAdvancedSettings = config.autoMarkAsDone || isMindsetBankConfigured || !containsDistributed && config.managersCreateAssets;
  function formatPayload() {
    var _fields$ownerTeamIds$, _fields$ownerTeamIds$2;
    var contentData = {
      locale: fields.locale.changedValue,
      completionTime: fields.completionTime.wasChanged ? Number(fields.completionTime.value) : undefined,
      markAsDoneMode: fields.markAsDoneMode.changedValue !== 'mixed' ? fields.markAsDoneMode.changedValue : undefined,
      ownerTeamId: (_fields$ownerTeamIds$ = (_fields$ownerTeamIds$2 = fields.ownerTeamIds.changedValue) === null || _fields$ownerTeamIds$2 === void 0 ? void 0 : _fields$ownerTeamIds$2[0]) !== null && _fields$ownerTeamIds$ !== void 0 ? _fields$ownerTeamIds$ : undefined,
      excludeFromAi: fields.excludeFromAi.changedValue !== 'mixed' ? fields.excludeFromAi.changedValue : undefined
    };
    var payload = [];
    initialAssetDetailItems.forEach(function (asset) {
      var tags = getNewAssetTags({
        asset: asset,
        tagsToAdd: tagsToAdd,
        tagsToRemove: tagsToRemove
      });
      payload.push({
        changes: filterObject(_objectSpread(_objectSpread({}, contentData), {}, {
          tags: tags,
          excludeFromAi: asset.excludedFromAiByParent ? undefined : contentData.excludeFromAi
        })),
        id: asset.id
      });
    });
    return payload;
  }
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setIsSubmissionLoading(true);
            _context.prev = 1;
            _context.next = 2;
            return onSubmit(formatPayload());
          case 2:
            resetAll();
            setPendingCloseAfterSubmit(true);
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            setIsSubmissionLoading(false);
            setPendingCloseAfterSubmit(false);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit,
    children: [/*#__PURE__*/_jsx(UnsavedChangesBlockerModal, {
      hasUnsavedChanges: hasChanges,
      includeQueryParams: true
    }), /*#__PURE__*/_jsxs(Stack, {
      spacing: "m",
      children: [/*#__PURE__*/_jsx(TitleCard, {
        variant: "raised",
        title: t('actions_edit_asset_plural', {
          count: assetIds.length
        }),
        children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
          horizontal: true,
          children: /*#__PURE__*/_jsxs(FormStack, {
            spacing: "l",
            children: [containsDistributed && /*#__PURE__*/_jsx(Hint, {
              icon: "share",
              children: t('immutability_note_selection_contains_distributed_asset_fields')
            }), /*#__PURE__*/_jsx(TagField, {
              isMultiSelect: true,
              contentType: "asset",
              selectedTags: formatTags(selectedTags),
              onChangeSelectedTags: function onChangeSelectedTags(data) {
                addTag(data.itemsToAdd);
                removeTag(data.itemsToRemove);
              },
              isDisabled: containsDistributed
            }), config.assetLanguageEnabled && /*#__PURE__*/_jsx(LanguageField, {
              value: fields.locale.value,
              onChange: function onChange(newPlaylistLocale) {
                return fields.locale.set(newPlaylistLocale);
              },
              isDisabled: containsDistributed
            }), /*#__PURE__*/_jsx(CompletionTimeField, {
              completionTime: fields.completionTime.value !== undefined && fields.completionTime.value !== null ? Number(fields.completionTime.value) : undefined,
              onChange: function onChange(e) {
                return fields.completionTime.set(Number(e.target.value));
              },
              isDisabled: containsDistributed
            })]
          })
        })
      }), hasAdvancedSettings && /*#__PURE__*/_jsx(TitleCard, {
        variant: "raised",
        title: t('menu_advanced_settings'),
        children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
          horizontal: true,
          children: /*#__PURE__*/_jsxs(FormStack, {
            spacing: "m",
            children: [config.autoMarkAsDone && /*#__PURE__*/_jsx(MarkAsDoneModeField, {
              isMultiSelect: true,
              isScormCourse: includesScormCourses,
              initialMode: fields.markAsDoneMode.defaultValue,
              mode: fields.markAsDoneMode.value,
              resetMarkAsDoneMode: fields.markAsDoneMode.reset,
              onChange: function onChange(newMode) {
                var _fields$markAsDoneMod;
                return (_fields$markAsDoneMod = fields.markAsDoneMode) === null || _fields$markAsDoneMod === void 0 ? void 0 : _fields$markAsDoneMod.set(newMode);
              }
            }), isMindsetBankConfigured && /*#__PURE__*/_jsx(ExcludeFromAIField, {
              value: fields.excludeFromAi.wasChanged ? fields.excludeFromAi.value : commonExcludeFromAi.excludeResult,
              onChange: function onChange(value) {
                return fields.excludeFromAi.set(value);
              },
              isDisabled: commonExcludeFromAi.allExcludedByParent,
              description: commonExcludeFromAi.allExcludedByParent && t('hint_exclude_from_ai_distributed_content') || commonExcludeFromAi.description
            }), !containsDistributed && config.managersCreateAssets && /*#__PURE__*/_jsx(AssetOwningTeamField, {
              values: fields.ownerTeamIds.value,
              defaultOwnerTeamIds: fields.ownerTeamIds.defaultValue,
              contentIds: assetIds,
              onChange: function onChange(ownerTeamIds) {
                return fields.ownerTeamIds.set(ownerTeamIds);
              }
            })]
          })
        })
      })]
    }), /*#__PURE__*/_jsx(EditorPageStickySaveDiscardButton, {
      hasChanges: hasChanges,
      isDisabled: hasErrors,
      isSaving: isSubmissionLoading,
      onDiscard: resetAll,
      buttonText: t('actions_done'),
      cardVariant: "raised"
    })]
  });
}
export default MultiAssetDetailsPage;